export const TICK_MS = 150;

/** Ticks as an RxJS operator's own argument reads them — real milliseconds, not sim ticks. */
export function ticksToMs(ticks: number): number {
  return ticks * TICK_MS;
}
